import "./App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Toaster } from "./components/ui/toaster";
import Landing from "./pages/Landing";
import { Login, Signup } from "./pages/Auth";
import AppShell from "./components/AppShell";
import Dashboard from "./pages/Dashboard";
import Employees from "./pages/Employees";
import ComingSoon from "./pages/ComingSoon";
import Settings from "./pages/Settings";
import AdminConsole from "./pages/AdminConsole";
import Leave from "./pages/Leave";
import Attendance from "./pages/Attendance";
import Portal from "./pages/Portal";
import Time from "./pages/Time";
import Kiosk from "./pages/Kiosk";

function Protected({ children }) {
  const { session, ready } = useAuth();
  if (!ready) return null;
  if (!session) return <Navigate to="/login" replace />;
  if (session.user?.role === "super_admin") return <Navigate to="/admin" replace />;
  return children;
}

function AdminProtected({ children }) {
  const { session, ready } = useAuth();
  if (!ready) return null;
  if (!session) return <Navigate to="/login" replace />;
  if (session.user?.role !== "super_admin") return <Navigate to="/app/dashboard" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/app" element={<Protected><AppShell /></Protected>}>
              <Route index element={<Navigate to="/app/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="employees" element={<Employees />} />
              <Route path="leave" element={<Leave />} />
              <Route path="attendance" element={<Attendance />} />
              <Route path="time" element={<Time />} />
              <Route path="payroll" element={<ComingSoon page="payroll" />} />
              <Route path="documents" element={<ComingSoon page="documents" />} />
              <Route path="reports" element={<ComingSoon page="reports" />} />
              <Route path="compliance" element={<ComingSoon page="compliance" />} />
              <Route path="settings" element={<Settings />} />
            </Route>
            <Route path="/admin" element={<AdminProtected><AdminConsole /></AdminProtected>} />
            <Route path="/portal/:code" element={<Portal />} />
            <Route path="/time" element={<Kiosk />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
